import { App } from 'vue'
import { PaddlePlugin } from './interface'
import { initializePaddle, InitializePaddleOptions, Paddle } from '@paddle/paddle-js'
import { PADDLE_INJECTION_KEY, PADDLE_TOKEN } from './constants'
import { ref } from 'vue'

export class PaddleImplementation implements PaddlePlugin {
  private initializeOptions: InitializePaddleOptions
  _paddle = ref<Paddle>();

  constructor(initializeOptions: InitializePaddleOptions) {
    this.initializeOptions = initializeOptions
  }

  async install(app: App): Promise<void> {
    try {
      this._paddle.value = await initializePaddle(this.initializeOptions)
    } catch (err) {
      console.error(err)
      throw new Error(`[PADDLE]: could not load paddle`)
    }

    console.log(`[PADDLE]: successfully installed paddle`)
    app.config.globalProperties[PADDLE_TOKEN] = this;
    app.provide(PADDLE_INJECTION_KEY, this)
  }

  get paddle () {
    const isDefined = this._paddle.value

    if(isDefined) return isDefined

    throw new Error(`[PADDLE] paddle not initialized`)
  }
}
